import { string } from 'yup';

const name = string().max(255, 'Name must be 255 characters or less').required('Please enter a name');

export { name };
